export function getCookie(name: string): string | null {
    if (typeof document === 'undefined') return null;
    const match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
}

export function setCookie(name: string, value: string, options?: { maxAgeSeconds?: number; path?: string; sameSite?: 'Lax' | 'Strict' | 'None'; secure?: boolean }) {
    if (typeof document === 'undefined') return;
    const parts: string[] = [];
    parts.push(`${name}=${encodeURIComponent(value)}`);
    parts.push(`Path=${options?.path ?? '/'}`);
    if (options?.maxAgeSeconds) parts.push(`Max-Age=${options.maxAgeSeconds}`);
    parts.push(`SameSite=${options?.sameSite ?? 'Lax'}`);
    if (options?.secure) parts.push('Secure');
    document.cookie = parts.join('; ');
}


